import React from "react";
import { Link } from "react-router-dom";
import { Project, featuredProjects } from "../data/projects";
import ProjectArtwork from "../components/ProjectArtwork";

export default function ProjectPage({ project }: { project: Project }) {
  return (
    <div className={`container project-detail detail-${project.id}`}>
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span aria-hidden="true">/</span>
        <Link to="/projects">Projects</Link>
        <span aria-hidden="true">/</span>
        <span aria-current="page">{project.name}</span>
      </nav>
      <header className="detail-intro">
        <div>
          <p className="eyebrow">{project.category}</p>
          <div className="detail-name">
            <img src={project.icon} alt="" width="72" height="72" />
            <h1>{project.name}</h1>
          </div>
          <h2>{project.tagline}</h2>
          <p>{project.description}</p>
          <div className="button-row">
            <a className="button" href={project.link}>
              Visit {project.name} <span aria-hidden="true">↗</span>
            </a>
            <span className="platform-label">{project.platform}</span>
          </div>
        </div>
        <div className="detail-artwork">
          <ProjectArtwork project={project} />
        </div>
      </header>
      <section className="project-story">
        <p className="eyebrow">About the product</p>
        <h2>
          {project.id === "veld"
            ? "A clearer view of your herd."
            : project.id === "fable"
              ? "A little imagination goes a long way."
              : "Built around the way you work."}
        </h2>
        <p>{project.story}</p>
      </section>
      <section className="feature-grid" aria-label={`${project.name} features`}>
        {project.features.map((feature, index) => (
          <div key={feature.title}>
            <span className="feature-number">0{index + 1}</span>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </section>
      {project.id === "veld" && (
        <p className="product-note">
          Breeding comparisons depend on the records and evaluation data you
          provide. Veld supports your review and does not replace an official
          genetic evaluation.
        </p>
      )}
      {project.socialLinks && (
        <nav className="social-links" aria-label={`Follow ${project.name}`}>
          <span>Follow {project.name}</span>
          {project.socialLinks.map((link) => (
            <a key={link.label} href={link.url}>
              {link.label} <span aria-hidden="true">↗</span>
            </a>
          ))}
        </nav>
      )}
      <aside className="related-projects">
        <h2>Keep exploring.</h2>
        <div>
          {featuredProjects
            .filter((other) => other.id !== project.id)
            .map((other) => (
              <Link key={other.id} to={`/projects/${other.id}`}>
                <img src={other.icon} width="40" height="40" alt="" />
                <span>{other.name}</span>
                <span aria-hidden="true">↗</span>
              </Link>
            ))}
        </div>
      </aside>
    </div>
  );
}
